import { render, staticRenderFns } from "./GlobalServicesTable.vue?vue&type=template&id=0b65fa1e&"
import script from "./GlobalServicesTable.vue?vue&type=script&lang=js&"
export * from "./GlobalServicesTable.vue?vue&type=script&lang=js&"
import style0 from "./GlobalServicesTable.vue?vue&type=style&index=0&id=0b65fa1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports